import { render } from "./JobDetailsForm.vue?vue&type=template&id=c3192be0"
import script from "./JobDetailsForm.vue?vue&type=script&lang=js"
export * from "./JobDetailsForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/workix-frontend-vue/workix-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__